import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { environment } from 'src/environments/environment';
import { formatDate } from '@angular/common';
import CryptoES from 'crypto-es';

declare let imageCompression: any;

@Injectable({
  providedIn: 'root'
})
export class HelperService {
  btnLoading: boolean = false;
  constructor(
    @Inject(LOCALE_ID) private locale: string) {
  }
  public hashFragmentToJson(params: string) {
    return JSON.parse(
      '{"' +
      decodeURI(params)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
    );
  }
  decodeJWT = (token: string) => JSON.parse(atob(token.split('.')[1]));

  setLocalStorage(key: any, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }
  getLocalStorage(key: any | null) {
    let value = localStorage.getItem(key);
    if (typeof value == "string") {
      return JSON.parse(value || '');
    }
    else {
      return JSON.parse(value || '{}');
    }
  }
  removeLocalStorage(key: string) {
    localStorage.removeItem(key);
  }
  setSessionStorage(key: any, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }
  getSessionStorage(key: any | null) {
    return JSON.parse(sessionStorage.getItem(key) || '{}');
  }
  getServerLocation() {
    return parseInt(localStorage.getItem('serverLocation') || '1', 10);
  }
  salseOrderQueryParams(perm : any) {
     perm.server_location = this.getServerLocation();
    return perm;
  }

  removeSessionStorage(key: string) {
    sessionStorage.removeItem(key);
  }
  encrypt(token: any) {
    let _key = CryptoES.enc.Utf8.parse(environment.encryptionKey);
    let _iv = CryptoES.enc.Utf8.parse(environment.encryptionIv);
    let encrypted = CryptoES.AES.encrypt(token, _key, {
      iv: _iv,
      mode: CryptoES.mode.CBC,
      padding: CryptoES.pad.Pkcs7,
    });
    return encrypted.toString();
  }
  // getBase64(key: any) {
  //   return btoa(key);
  // }

  getBase64(key: any, server_location?: any) {
    if (server_location == 9) {
      const uridata = encodeURIComponent(key);
      return btoa(uridata);
    } else {
      return btoa(key);
    }
  }

  setCookie(cookieName: string, cookieValue: string, expiryDays: any) {
    let d = new Date();
    d.setTime(d.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
  }

  async compressImage(file: any) {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    }
    try {
      return await imageCompression(file, options);
    } catch (error) {
    }
  }

  compressImageSize(file: File, maxWidth: number, maxHeight: number, quality: number): Promise<File> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          if (ctx) {
            ctx.drawImage(img, 0, 0, width, height);
            canvas.toBlob((blob) => {
              const compressedFile = new File([blob!], file.name, { type: 'image/jpeg', lastModified: Date.now() });
              resolve(compressedFile);
            }, 'image/jpeg', quality);
          } else {
            reject(new Error('Canvas context is not supported'));
          }
        };
        img.src = reader.result as string;
      };
      reader.readAsDataURL(file);
    });
  }

  getOsAndBrowserName() {
    let OSName = "Unknown OS";
    if (window.navigator.userAgent.indexOf("Win") != -1) OSName = "Windows";
    if (window.navigator.userAgent.indexOf("Mac") != -1) OSName = "MacOS";
    if (window.navigator.userAgent.indexOf("X11") != -1) OSName = "UNIX";
    if (window.navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";
    if (window.navigator.userAgent.indexOf("Linux x86_64") != -1) OSName = "Ubuntu";

    let nAgt = navigator.userAgent;
    let browserName = window.navigator.userAgent;
    let fullVersion = '' + parseFloat(window.navigator.userAgent);
    let majorVersion = parseInt(window.navigator.userAgent, 10);
    let nameOffset, verOffset, ix;

    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset = nAgt.indexOf("Opera")) != -1) {
      browserName = "Opera";
      fullVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf("Version")) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
      browserName = "Microsoft Internet Explorer";
      fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
      browserName = "Chrome";
      fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
      browserName = "Safari";
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf("Version")) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
      browserName = "Firefox";
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
      (verOffset = nAgt.lastIndexOf('/'))) {
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = window.navigator.userAgent;
      }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(";")) != -1)
      fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(" ")) != -1)
      fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
      fullVersion = '' + parseFloat(window.navigator.userAgent);
      majorVersion = parseInt(window.navigator.userAgent, 10);
    }
    browserName = `${browserName}(${fullVersion})`;
    return { OSName, browserName };
  }
  stringConvertToTitleCase(string: string) {
    return string.split(' ')
      .map(s => s.slice(0, 1).toUpperCase() + s.slice(1).toLowerCase())
      .join(' ')
  }

  // Convert for chat
  getConvertedDateForPackets(date: any) {
    if (new Date().toLocaleDateString() == new Date(date).toLocaleDateString()) {
      return 'Today';
    }
    else if (new Date(date).toLocaleDateString() == this.subtractDays(new Date(), 1).toLocaleDateString()) {
      return 'Yesterday';
    }
    else {
      return formatDate(date, 'dd LLL yyyy', this.locale);
    }
  }
  subtractDays(date: any, days: any) {
    let result = new Date(date);
    result.setDate(result.getDate() - days);
    return result;
  }
  dateTimeLeft(date: any) {
    const convertDate = new Date(date);
    const currentDate = new Date();

    const inSeconds = (+convertDate - +currentDate) / 1000;
    const time = [];

    const year = 31536000;
    const month = 2592000;
    const week = 604800;
    const day = 86400;
    const hour = 3600;
    const minute = 60;
    const second = 1;

    let remaining = inSeconds;

    if (remaining / year >= 1) {
      let years = +Math.floor(remaining / year).toFixed(0)
      time.push(years + ' year');
      remaining -= (years * year);
    }
    if (remaining / month >= 1) {
      let months = +Math.floor(remaining / month).toFixed(0)
      time.push(months + ' month');
      remaining -= (months * month);
    }
    if (remaining / week >= 1) {
      let weeks = +Math.floor(remaining / week).toFixed(0)
      time.push(weeks + ' week');
      remaining -= (weeks * week);
    }
    if (remaining / day >= 1) {
      let days = +Math.floor(remaining / day).toFixed(0)
      time.push(days + ' day');
      remaining -= (days * day);
    }
    if (remaining / hour >= 1) {
      let hours = +Math.floor(remaining / hour).toFixed(0)
      time.push(hours + ' hours');
      remaining -= (hours * hour);
    }
    if (remaining / minute >= 1) {
      let minutes = +Math.floor(remaining / minute).toFixed(0)
      time.push(minutes + ' minutes');
      remaining -= (minutes * minute);
    }
    if (remaining / second >= 1) {
      let seconds = +Math.floor(remaining / second).toFixed(0)
      time.push(seconds + ' second');
      remaining -= (seconds * second);
    }
    if (time.length >= 2) {
      return time[0] + ' and ' + time[1];
    } else {
      return time[0];
    }
  }
  // Date Left for Doctor page
  dateLeftDoctor(date: any) {
    if (new Date().toLocaleDateString() == new Date(date).toLocaleDateString()) {
      return 'Today';
    }
    else if (new Date(date).toLocaleDateString() == this.addDays(new Date(), 1).toLocaleDateString()) {
      return 'Tomorrow';
    }
    else if (new Date(date).toLocaleDateString() == this.addDays(new Date(), 2).toLocaleDateString()) {
      return 'In 2 days';
    }
    else if (new Date(date).toLocaleDateString() == this.addDays(new Date(), 3).toLocaleDateString()) {
      return 'In 3 days';
    }
    else if (new Date(date).toLocaleDateString() == this.addDays(new Date(), 4).toLocaleDateString()) {
      return 'In 4 days';
    }
    else if (new Date(date).toLocaleDateString() == this.addDays(new Date(), 5).toLocaleDateString()) {
      return 'In 5 days';
    }
    else if (new Date(date).toLocaleDateString() == this.addDays(new Date(), 6).toLocaleDateString()) {
      return 'In 6 days';
    }
    else if (new Date(date).toLocaleDateString() == this.addDays(new Date(), 7).toLocaleDateString()) {
      return 'In a week';
    }
    else {
      return this.getDate(date);
    }
  }
  // Feb 16, 2021
  getDate(myDate: any) {
    myDate = new Date(myDate);
    let date;
    if (myDate.toString().match("/") || (myDate.toString().match("-") && ((myDate.toString().match(new RegExp("-", "g")) || []).length == 2))) {
      date = new Date(myDate.replace(/-/g, "/")).toString().split(" ")
    }
    else {
      date = new Date(myDate).toString().split(" ")
    }
    return `${date[2]} ${date[1]}, ${date[3]}`
  }
  getDateReportFormat(myDate: any) {
    myDate = new Date(myDate);
    let date;
    if (myDate.toString().match("/") || (myDate.toString().match("-") && ((myDate.toString().match(new RegExp("-", "g")) || []).length == 2))) {
      date = new Date(myDate.replace(/-/g, "/")).toString().split(" ")
    }
    else {
      date = new Date(myDate).toString().split(" ")
    }
    return `${date[1]} ${date[2]}, ${date[3]}`
  }
  // 9:00 PM
  getTime(date: any) {
    date = new Date(date);
    if (date.toString().match("/") || (date.toString().match("-") && ((date.toString().match(new RegExp("-", "g")) || []).length == 2))) {
      return new Date(date.replace(/-/g, "/")).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    }
    else {
      return new Date(date).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    }
  }
  formatTimestampForChat(created_at_with_time: { seconds: number; nanoseconds: number }): string {
    if (!created_at_with_time) return '';

    // Convert the timestamp to a Date object
    const date = new Date(created_at_with_time.seconds * 1000 + created_at_with_time.nanoseconds / 1000000);

    // Extract day, month, year, hours, and minutes
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const amPm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 24-hour time to 12-hour time

    // Return the formatted string
    return `${day}-${month}-${year} ${hours}:${minutes} ${amPm}`;
  }

  getDateAndTime(dateTime: any, returnNa: any = 'N/A') {
    if (dateTime && dateTime != '') {
      return this.getDate(dateTime) + " " + this.getTime(dateTime);
    } else {
      return returnNa;
    }
  }
  // 15/03/2020
  getSlashDate(date: any) {
    let d;
    if (date.match("Z")) {
      d = new Date(date);
    }
    else if (date.toString().match("/") || date.toString().match("-") && ((date.toString().match(new RegExp("-", "g")) || []).length == 2)) {
      d = new Date(date.replace(/-/g, "/"));
    }
    else {
      d = new Date(date);
    }
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`
  }
  // Date and time convert to single date objects.
  dateTimeConvertNewDate(date: any, time: any) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds());
  }

  // Compare Two Time value - (12:00:00, 12:00:00)
  compareTime(firstTime: any, secondTime: any) {
    if (firstTime instanceof Date) {
      firstTime = this.getTimeString(firstTime);
    }
    if (secondTime instanceof Date) {
      secondTime = this.getTimeString(secondTime);
    }

    if (firstTime > secondTime)
      return true;
    else
      return false;
  }
  // new Date() convert to 12:00:00
  getTimeString(date: any) {
    return date.toTimeString().substring(0, 8);
  }
  // new Date() convert to 08-Feb-2006
  convertDashDateWithMonthName(date: any) {
    let d = (new Date(date) + '').split(' ');
    return `${d[2]}-${d[1]}-${d[3]}`;
  }
  // new Date() convert to 2000-03-03
  convertDashDate(date: any) {
    let d;
    if (date.toString().match("/") || (date.toString().match("-") && ((date.toString().match(new RegExp("-", "g")) || []).length == 2))) {
      d = new Date(date.replace(/-/g, "/"));
    }
    else {
      d = new Date(date);
    }
    return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  }
  // Add day in cuurent date
  addDays(date: any, days: any) {
    return new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
  }
  // Add month to new Date()
  addMonthToDate(date: any, months: any) {
    return new Date(date.setMonth(date.getMonth() + months));
  }
  // Subtract month to new Date()
  subtractMonthToDate(date: any, months: any) {
    return new Date(date.setMonth(date.getMonth() - months));
  }
  // new Date() convert to Tuesday 30, 2021
  dateFullDayYear(date: any) {
    if (new Date().toLocaleDateString() == new Date(date).toLocaleDateString()) {
      return 'Today';
    }
    else {
      let o: any = new Intl.DateTimeFormat("en", {
        weekday: "long",
        day: "2-digit",
        year: "numeric"
      });
      o = o.format(date).split(" ");
      return `${o[1]}, ${o[0]}, ${o[2]}`;
    }
  }
  // new Date() convert to { year:2000, month:03, date:03 }
  getDateMonthyearInObject(date: any) {
    let d;
    if (date.toString().match("/") || date.toString().match("-")) {
      d = new Date(date.replace(/-/g, "/"));
    }
    else {
      d = new Date(date);
    }
    return { year: d.getFullYear(), month: (d.getMonth() + 1), date: d.getDate() };
  }
  // new Date to get full day name Saturday
  getFulldayName(date: any) {
    return date.toLocaleString('en-us', { weekday: 'long' });
  }

  // new Date() convert to 2000-03-03
  convertToDashDate(date: Date): string {
    date = new Date(date);
    let month: string = (date.getMonth() + 1) < 10 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`;
    let day: string = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`;
    return `${date.getFullYear()}-${month}-${day}`;
  }

  getFormattedTreatmentName(item: any): string {
    return item
      ? item.replace(/\(R\)/g, '<sup>®</sup>')
      : '';
  }
}
